// extracted by mini-css-extract-plugin
export default {"inputs":"CampaignGoalInput_inputs__iKxiu"};